import formatTravelModes from '../formatTravelModes';

const formatBookButtonTextByModes = (itinerariesOnHold, itinerariesToBook) => `Hold ${formatTravelModes(itinerariesOnHold)}${itinerariesToBook.length ? ` + book ${formatTravelModes(itinerariesToBook)}` : ''}`;

export default formatBookButtonTextByModes;
